import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import Header from "../components/Header";
import Lookup from "../components/Lookup";
import { useLocation } from "react-router-dom";

const Channel = () => {
  const [data, setData] = useState([]);
  const [videos, setVideos] = useState([]);
  const [image, setImage] = useState("");
  const [subcount, setSubcount] = useState("");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const selectedInstance = searchParams.get("instance");
  const { channel } = useParams();
  const url = `${selectedInstance}/api/v1/channels/${channel}`;

  useEffect(() => {
    fetch(url)
      .then((res) => res.json())
      .then((json) => {
        setImage(json["authorThumbnails"][4]["url"]);
        setVideos(json["latestVideos"]);
        setData(json);
        if (json["subCount"] > 999 && json["subCount"] < 1000000) {
          setSubcount((json["subCount"] / 1000).toFixed(1) + "K");
        } else if (json["subCount"] > 1000000) {
          setSubcount((json["subCount"] / 1000000).toFixed(1) + "M");
        } else if (json["subCount"] < 900) {
          setSubcount(json["subCount"]);
        }
        document.title = json["author"];
      });
  }, [subcount]);

  return (
    <>
      <Header />
      <Lookup selectedInstance={selectedInstance} />
      <div className="max-w-md mx-auto bg-white rounded-xl shadow-md overflow-hidden md:max-w-2xl p-4 border border-gray-200 w-3/4">
        <div className="flex items-center">
          <img
            className="object-cover h-24 w-24 md:h-full md:w-48 rounded-full"
            src={image}
            alt={data["author"]}
          />
          <div className="ml-4">
            <div className="uppercase tracking-wide text-sm text-red-500 font-semibold md:text-2xl text-xl">
              {data["author"]}
            </div>
            <a
              href="#"
              className="block mt-2 text-lg leading-tight font-medium text-gray-800"
            >
              Subscribers: {subcount}
            </a>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap">
        <div className="p-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4 xl:container mx-auto">
          {videos.map((trend) => (
            <div className="relative" key={trend.videoId}>
              <Link
                to={{
                  pathname: `/player/${trend["videoId"]}`,
                  search: `?instance=${selectedInstance}`,
                }}
              >
                <img
                  className="w-full object-cover object-center rounded-lg"
                  src={`https://i.ytimg.com/vi_webp/${trend["videoId"]}/mqdefault.webp`}
                  alt={trend["title"]}
                />
              </Link>
              <h3 className="mt-2 tracking-widest text-indigo-500 text-xs font-medium title-font">
                <Link
                  to={{
                    pathname: `/channel/${trend["authorId"]}`,
                    search: `?instance=${selectedInstance}`,
                  }}
                >
                  {trend["author"]}
                </Link>
              </h3>
              <h2 className="text-lg text-gray-900 font-medium title-font mb-4">
                <Link
                  to={{
                    pathname: `/player/${trend["videoId"]}`,
                    search: `?instance=${selectedInstance}`,
                  }}
                >
                  {trend["title"]}
                </Link>
              </h2>
              <p className="-mt-4 leading-relaxed text-base">
                {(() => {
                  const dateObj = new Date(trend["lengthSeconds"] * 1000);
                  const hours = dateObj.getUTCHours();
                  const minutes = dateObj.getUTCMinutes();
                  const seconds = dateObj.getSeconds();
                  return (
                    hours.toString().padStart(2, "0") +
                    ":" +
                    minutes.toString().padStart(2, "0") +
                    ":" +
                    seconds.toString().padStart(2, "0")
                  );
                })()}
                <span className="ml-2">{trend["publishedText"]}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Channel;
